<template>
    <figure v-if="image">
        <img :src="image" :alt="alt" />
    </figure>
</template>

<style lang="scss" scoped>
    @import '../../../sass/variables';

    figure {
        width: 100%;
        max-width: $custom-container-max-width-padding;
        text-align: center;
        margin: 0 auto;
    }

    img {
        display: block;
        width: auto;
        max-width: 100%;
        margin: 0 auto;
    }
</style>

<script>
    export default {
        props: {
            image: String,
            alt: String,
        },
    }
</script>
